import Fetch from "utils/fetch";

export const getInvoicesOrdersBySapOrderCode = (sapOrderCode) =>
  Fetch.get(`orders:invoices?SapOrderCode=${sapOrderCode}`).then(({ data }) => data);
